var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"overflow-x":"hidden"}},[_c('BannerStatic',{attrs:{"ban":_vm.wWidth<768?_vm.banner[1]:_vm.banner[0]},on:{"scroll-job":_vm.handleScrollToJob}}),_c('People',{ref:"peopleRef",staticClass:"px-xs-32"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }